import { render, staticRenderFns } from "./dposLinkageBox.vue?vue&type=template&id=b63f92e8&scoped=true&"
import script from "./dposLinkageBox.vue?vue&type=script&lang=js&"
export * from "./dposLinkageBox.vue?vue&type=script&lang=js&"
import style0 from "./dposLinkageBox.vue?vue&type=style&index=0&id=b63f92e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63f92e8",
  null
  
)

export default component.exports